export default "__VITE_ASSET__3c9999ca__"